import * as React from 'react';
import { View, Text, StyleSheet, Image, Platform } from 'react-native';
import { PropsModelTri } from '../../types';
import  {themePattern}  from '../../constants/pattern';
import { aminoacidos } from '../../assets/aminoacidos';

console.log(aminoacidos(1).info[0]);

// Todas as imagens dos aminoacidos
const ala = require('./../../assets/models/ala.gif');
const arg = require('./../../assets/models/arg.gif');
const asn = require('./../../assets/models/asn.gif');
const asp = require('./../../assets/models/asp.gif');
const cys = require('./../../assets/models/cys.gif');
const gln = require('./../../assets/models/gln.gif');
const glu = require('./../../assets/models/glu.gif');
const gly = require('./../../assets/models/gly.gif');
const his = require('./../../assets/models/his.gif');
const ile = require('./../../assets/models/ile.gif');
const leu = require('./../../assets/models/leu.gif');
const lys = require('./../../assets/models/lys.gif');
const met = require('./../../assets/models/met.gif');
const phe = require('./../../assets/models/phe.gif');
const pro = require('./../../assets/models/pro.gif');
const ser = require('./../../assets/models/ser.gif');
const thr = require('./../../assets/models/thr.gif');
const trp = require('./../../assets/models/trp.gif');
const tyr = require('./../../assets/models/tyr.gif');
const val = require('./../../assets/models/val.gif');


const model = [ala, arg, asn, asp, cys, gln, glu, gly, his, ile, leu, lys, met, phe, pro, ser, thr, trp, tyr, val]


// https://molview.org/ - CID -  código das estruturas no servidor RCSB
const modelMolview = [602, 6322, 6267, 5960, 5862, 6140, 750, 5128032, 5961, 6274, 6306, 6106, 5962, 6137, 145742, 5951, 6057, 6288, 6305, 6287]

export default function ModalTri({aminoAcid}:PropsModelTri) {


  const {name, info} = aminoacidos(aminoAcid)

  const tridimencional = Platform.select({
    ios: () => gifVersion,
    android: () => gifVersion,
    default: () => iframeVersion,
  })();


  // Soluções da vizualização 3D - Sempre verificar se esta operando https://molview.org/

  function gifVersion(){
    return (
      <Image source={model[aminoAcid]} style={stylesModal.image} resizeMode ='contain' />
    )
  }

  function iframeVersion(){
    return (
      <iframe width="100%" height="100%" frameBorder="0"  src={`https://embed.molview.org/v1/?mode=balls&cid=${modelMolview[aminoAcid]}&bg=white`}/>
    )
    }
  
    return (
            <View style={stylesModal.containerImage}>
              {tridimencional()}
            </View>
    );
  }
  
  const stylesModal = StyleSheet.create({
    containerImage:{ 
        padding:10,
        flexGrow:1
        

    }, 
    image:{
        padding: 10,
        borderRadius: 10,

        height: '100%',
        width:'100%'
        
    }
  });
